import { ReactNode } from "react";
import { ValueOf } from "utils/typeCheck.utils";

export const INFO_VARIANT = {
  SUCCESS: "success",
  ERROR: "error",
} as const;

export interface InfoProps {
  variant: ValueOf<typeof INFO_VARIANT>;
  children: ReactNode;
  onClose?: () => void;
  className?: string;
}
